import { useEffect } from "react";
import { collect, store } from "react-recollect";
import Loading from "./Loading";
import { certGETj } from "lib/API";

async function getAuths() {
  const a = await certGETj("auths");
  store.auths = a;
}

function LoadAuths() {
  useEffect(() => {
    getAuths();
  }, []);

  return <Loading text="Loading Certificate System: auths" />;
}

export default collect(LoadAuths);
